import React, { useState, useEffect, useRef } from 'react';
import { Table, Button, Input, Select, DatePicker, Modal, Tag, Skeleton, Tooltip } from 'antd';
import { FaFileAlt, FaAnchor, FaTimes } from 'react-icons/fa';
import TabCpn from '../tinchap/func/TabCpn';
import '../../css/BadgeAnt.css'
import moment from 'moment';
import dayjs from 'dayjs';

const { Option } = Select;

const CustomModal = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    const handleBackgroundClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="custom-modal-overlay" onClick={handleBackgroundClick}>
            <div className="custom-modal-content">
                <button className="custom-modal-close" onClick={onClose}>
                    &times;
                </button>
                {children}
            </div>
        </div>
    );
};


const CustomModalMenu = ({ isOpen, onClose, children, hasUnsavedChanges }) => {
    if (!isOpen) return null;

    const handleBackgroundClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="custom-modal-overlay" onClick={handleBackgroundClick}>
            <div className="custom-modal-menu-content">
                <button className="custom-modal-close" onClick={onClose}>
                    &times;
                </button>
                {children}
            </div>
        </div>
    );
};



const AlertTinChap = () => {
    const [data, setData] = useState([]);
    const [isOpenTabMenu, setOpenTabMenu] = useState(false);
    const [modalContent, setModalContent] = useState({ tab: "1", id: null }); // New state to hold tab and id
    const [loading, setLoading] = useState(true); // Loading state for the skeleton
    const [txtMaHD, setTxtMaHD] = useState('');
    const [txtTenKH, setTxtTenKH] = useState('');
    const [txtCMND, setTxtCMND] = useState('');
    const [txtPhone, setTxtPhone] = useState('');
    const [pageSize, setPageSize] = useState(100); // Số dòng hiển thị mặc định
    const [currentPage, setCurrentPage] = useState(1); // Trang hiện tại
    const [selectedCode, setSelectedCode] = useState("0");

    const handleSelectChange = (value) => {
        setSelectedCode(value);
    };

    useEffect(() => {
        //console.log("Selected code: " + selectedCode)
        fetchData();
    }, [selectedCode])


    const handleTableChange = (pagination) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const fetchData = () => {
        setLoading(true);
        const params = new URLSearchParams();

        if (txtMaHD.trim()) {
            params.append('loanId', txtMaHD.trim());
        }

        if (txtTenKH.trim()) {
            params.append('name', txtTenKH.trim());
        }

        if (txtCMND.trim()) {
            params.append('numberCard', txtCMND.trim());
        }

        if (txtPhone.trim()) {
            params.append('phone', txtPhone.trim());
        }

        params.append('code', Number(selectedCode));

        const token = localStorage.getItem('token'); // Thay 'your_token_key' bằng key thực tế

        fetch(`${process.env.REACT_APP_API_DB_URL}/alert-credit?${params.toString()}`, {
            method: 'GET', // Hoặc 'POST' nếu cần thiết
            headers: {
                'Authorization': `Bearer ${token}`, // Thêm token vào headers
                'Content-Type': 'application/json' // Nếu cần
            }
        })
            .then(response => {
                // Kiểm tra mã trạng thái phản hồi
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(d => {
                // Kiểm tra kiểu dữ liệu
                if (Array.isArray(d) || typeof d === 'object') {
                    setData(d);
                } else {
                    console.warn('Dữ liệu không hợp lệ:', d);
                    setData([]); // Thiết lập thành mảng rỗng nếu dữ liệu không hợp lệ
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('Lỗi khi lấy dữ liệu:', error);
                setData([]); // Thiết lập thành mảng rỗng trong trường hợp có lỗi
                setLoading(false);
            });
    };


    const handleOpenTabMenu = (tab, id) => {
        setModalContent({ tab, id });
        setOpenTabMenu(true);
    };


    const columns = [
        { title: '#', dataIndex: 'index', key: 'index', render: (_, __, index) => index + 1 },
        {
            title: 'Mã HĐ',
            dataIndex: 'LOAN_ID',
            key: 'LOAN_ID',
            render: (text, record) => (
                <a
                    style={{
                        color: '#007bff', // Bootstrap primary color or use another
                        fontWeight: 'bold', // Make it bold
                        textDecoration: 'underline', // Add underline
                        cursor: 'pointer' // Make it look like it's clickable
                    }}
                >
                    {text}
                </a>
            )
        },

        {
            title: 'Khách hàng', dataIndex: 'NAME', key: 'NAME', render: (value) => (
                <span style={{ color: '#1677FF' }}>
                    <b>{value}</b>
                </span>)
        },
        { title: 'Địa chỉ', dataIndex: 'ADDRESS', key: 'ADDRESS' },
        {
            title: 'Nợ cũ', dataIndex: 'DEBIT_MONEY', key: 'DEBIT_MONEY', render: (value) => (
                <span style={{ color: 'red' }}>
                    <b>{value.toLocaleString('vi-VN')}</b>
                </span>)
        },
        {
            title: 'Tiền lãi', dataIndex: 'INTEREST_TODAY', key: 'INTEREST_TODAY', render: (value) => (
                <span style={{ color: 'red' }}>
                    <b>{value.toLocaleString('vi-VN')}</b>
                </span>)
        },
        {
            title: 'Tiền gốc', dataIndex: 'TOTAL_MONEY', key: 'TOTAL_MONEY', render: (value) => (
                <span style={{ color: 'red' }}>
                    <b>{value.toLocaleString('vi-VN')}</b>
                </span>)
        },
        {
            title: 'Tổng tiền', dataIndex: 'TOTAL_MONEY_ALERT', key: 'TOTAL_MONEY_ALERT', render: (value) => (
                <span style={{ color: 'blue' }}>
                    <b>{value.toLocaleString('vi-VN')}</b>
                </span>)
        },
        { title: 'Lý do', dataIndex: 'REASON', key: 'REASON' },
        {
            title: 'Trạng thái', dataIndex: 'STR_STATUS', key: 'STR_STATUS', render: (status) => (
                <Tag color={status === 'Nợ lãi' ? '#fcba03' : (status === 'Quá hạn' || status === 'Đến ngày trả gốc' ? '#F4516C' : '#108ee9')}>{status}</Tag>
            )
        },
        {
            title: 'Chức năng',
            key: 'actions',
            render: (_, record) => (
                <>
                    <div>
                        <Tooltip title="Đóng tiền">
                            <div className="flex items-center justify-center" style={{ height: '100%' }}>
                                <Button
                                    className="icon-button"
                                    type="link"
                                    style={{ fontSize: '24px' }} // Thay đổi kích thước của nút
                                    onClick={() => handleOpenTabMenu("1", record.LOAN_ID)}
                                    icon={<FaFileAlt style={{ color: '#fcba03' }} />}
                                />
                            </div>
                        </Tooltip>
                    </div>
                </>
            )
        }
    ];

    const summaryData = data.length > 0 ? data[data.length - 1] : { TotalMoney: 0, InterestMoneyReceived: 0, InterestToDay: 0 };



    const handleSearch = () => {
        fetchData();
    }

    //console.log("render add contract")

    return (
        <div className="md:p-1">
            <h1 className="text-xl md:text-2xl font-bold mb-4">Cảnh báo Tín Chấp</h1>

            <div className="flex flex-wrap mb-4">
                <Button type="primary" className="mr-2 mb-2">Xuất Excel</Button>
            </div>

            <div className="flex flex-wrap mb-4">
                <Input placeholder="Tìm kiếm mã HĐ" className="mr-2 mb-2 flex-1 min-w-[150px]" value={txtMaHD} onChange={(e) => setTxtMaHD(e.target.value)} onKeyDown={handleKeyDown} />
                <Input placeholder="Tìm kiếm tên KH" className="mr-2 mb-2 flex-1 min-w-[150px]" value={txtTenKH} onChange={(e) => setTxtTenKH(e.target.value)} onKeyDown={handleKeyDown} />
                <Input placeholder="Tìm kiếm CMND" className="mr-2 mb-2 flex-1 min-w-[150px]" value={txtCMND} onChange={(e) => setTxtCMND(e.target.value)} onKeyDown={handleKeyDown} />
                <Input placeholder="Tìm kiếm số điện thoại" className="mr-2 mb-2 flex-1 min-w-[150px]" value={txtPhone} onChange={(e) => setTxtPhone(e.target.value)} onKeyDown={handleKeyDown} />



                <Select defaultValue="Tất cả hợp đồng đang vay" className="mr-2 mb-2 flex-1 min-w-[150px]" style={{ width: 180 }} onChange={handleSelectChange}>
                    <Option value="0">Tất cả</Option>
                    <Option value="9">Đóng lãi hôm nay</Option>
                    <Option value="3">Chậm lãi</Option>
                    <Option value="10">Trả gốc hôm nay</Option>
                    <Option value="2">Quá hạn trả gốc</Option>
                    <Option value="11">Ngày mai đóng lãi</Option>
                </Select>
                <Button type="primary" className="mr-2 mb-2" onClick={handleSearch}>Tìm kiếm</Button>
            </div>
            {loading ?
                (<Skeleton active />) :

                (<Table
                    className="custom-table"
                    columns={columns}
                    dataSource={data}
                    rowKey={(record) => record.ID}
                    pagination={{
                        current: currentPage,
                        pageSize: pageSize,
                        total: data.length, // Tổng số dòng dữ liệu
                        onChange: (page, pageSize) => {
                            setCurrentPage(page);
                            setPageSize(pageSize);
                        },
                        showSizeChanger: true, // Hiển thị tùy chọn thay đổi số dòng
                        pageSizeOptions: [100,200,300], // Các tùy chọn số dòng
                    }}

                    scroll={{ x: 'max-content' }} // Enable horizontal scrolling when content exceeds container width

                />)}



            <CustomModalMenu isOpen={isOpenTabMenu} onClose={() => setOpenTabMenu(false)}>
                {<TabCpn tab={modalContent.tab} id={modalContent.id} />}
            </CustomModalMenu>

        </div>
    );
};

export default AlertTinChap;
